import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: '100%',
    height: '56.5vw',
    maxHeight: `calc(100% - ${theme.spacing(12)}px)`,
    backgroundColor: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',

    [theme.breakpoints.up('md')]: {
      height: 'calc(((100vw - 320px) * 56.5) / 100)',
      maxHeight: `calc(100% - ${theme.spacing(12)}px)`,
    },
  },
}));

export default styles;
